var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"catalog-product-item",class:{ retrofit: _vm.product.Retrofit }},[_c('router-link',{staticClass:"product-item",attrs:{"tabindex":"0","to":{
        name: _vm.productUrl,
        params: {
          product: _vm.product.Id,
        },
        query: {
          hotspots: _vm.product.GrafikId,
          vehicleSpecific: _vm.product.VehicleSpecific,
        },
      }}},[(_vm.product.PictureUrl)?_c('div',{staticClass:"product-item__img"},[_c('img',{attrs:{"src":_vm.pictureUrlPath(_vm.product.PictureUrl)}})]):_vm._e(),(_vm.product.Retrofit)?_c('div',{staticClass:"retrofit-text m-t-10"},[_vm._v(_vm._s(_vm.$t('Retrofit')))]):_vm._e(),_c('SfHeading',{staticClass:"product-item__title",attrs:{"title":_vm.product.Name,"description":_vm.product.Sku,"level":4}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }